import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { AudienceCapacity } from 'src/app/models/audience-models/audience-capacity.model';

@Component({
  selector: 'app-audience-capacity-average-card',
  templateUrl: './audience-capacity-average-card.component.html',
  styleUrls: ['./audience-capacity-average-card.component.scss']
})
export class AudienceCapacityAverageCardComponent implements OnInit, AfterContentChecked {

  @Input() data: AudienceCapacity;
  count: string;
  percent: string;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('average-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data)) {
      this.spinnerService.hide('average-counts-spinner');
      this.showCounter = true;
      this.count = this.data.AverageNumberCurrent.toFixed(0) + '/' + this.data.LimitNumberCurrent;
      this.percent = this.data.AverageComparison.toFixed(1);
    } else {
      this.count = '-';
      this.percent = '0.0';
      this.showCounter = true;
      this.spinnerService.hide('average-counts-spinner');
    }
  }

}
